import { algoliaClient } from '../api/algolia/algolia.client';
import { debounce } from '../js/debounce';
import { getStringCombinations } from '../utils/getStringCombinations';
import { dlDispatchAmplEvent } from '../events/dl.dispatchAmplEvent';
import { isNotNullOrUndef } from '../utils/isNotNullOrUndef';
import { MEDIA_BREAKPOINTS } from '../constants/MEDIA_BREAKPOINTS';
import { toggleBodyScroll } from '../utils/toggleBodyScroll';
import { runAfterWinLoadEvent } from '../utils/runAfterWinLoadEvent';
const { create, patch } = window.vNode;
const SESSION_KEY = 'r_searches';
const CLIENT = algoliaClient('K2CTT24UP3', '2ddbb0a8db153957543d851ca677c689').initIndex('Shopify Collections');
const mobileFullscreenClasses = ['pos:f', 'z:4', 't:0', 'l:0', 'w:100p', 'px:14', 'd:flex', 'fd:column', 'bg:white'];
const stickyWrapper = document.querySelector('.header-sticky-wrapper');
const isSearchPage = window.location.pathname === '/search';
const SpeechRecognition = window.SpeechRecognition ?? window.webkitSpeechRecognition;
const recognition = SpeechRecognition !== undefined
    ? new SpeechRecognition()
    : undefined;
if (recognition !== undefined) {
    recognition.lang = 'en-US';
    recognition.continuous = true;
    recognition.interimResults = false;
}
const suggestionListItems = ({ label, children }) => {
    return create('div', [
        create('span', { class: 'd:block fz:16 fw:700 px:10 px:16:lg-up' }, label),
        create('ul', { class: 'list:none mt:14' }, children)
    ]);
};
const suggestionListItem = ({ href, icon, label, parent, clickHandler }) => {
    return create('li', create('a', {
        href,
        class: 'd:block py:14 px:10 px:16:lg-up py:24:lg-up trs hover:bg:f4f4f4 focus:bg:f4f4f4',
        'data-suggestion-item': '',
        ...clickHandler !== undefined &&
            {
                events: {
                    click: clickHandler
                }
            }
    }, [
        create('span', { class: 'd:flex ai:center' }, [
            create('s-svg', {
                'data-icon': icon,
                class: 'h:16 w:16 color:text-light mr:14'
            }),
            create('span', { class: 'fz:14 color:text' }, label)
        ]),
        parent !== undefined && create('span', {
            class: 'd:block fz:14 lh:1 pl:28 ml:2 color:text-middle'
        }, parent)
    ]));
};
const backBtn = ({ clickHandler }) => create('button', {
    key: 'backBtn',
    class: 'btn:cleared as:start py:16 pl:10 pr:20 lh:0'
}, create('s-svg', {
    'data-icon': '#icon--arrow-slider-left',
    class: 'h:16',
    events: {
        click: clickHandler
    }
}));
const getRedirectFromResponse = (response) => {
    let result = null;
    try {
        const redirect = response.userData?.find(({ redirect }) => redirect !== undefined)?.redirect;
        if (redirect !== undefined) {
            result = {
                url: redirect.url,
                categoryType: 'custom',
                categoryName: 'custom',
                position: 1
            };
        }
        else if (response.hits.length > 0) {
            const variants = [];
            const words = response.explain?.match?.alternatives?.reduce((arr, { types, words, offset }) => {
                if (types[0] === 'concat') {
                    variants.push(...words);
                }
                if (types[0] === 'original' || types[0] === 'plural') {
                    if (arr[offset] !== undefined) {
                        arr[offset].push(...words);
                    }
                    else {
                        arr[offset] = words;
                    }
                }
                return arr;
            }, []);
            words?.length > 0 && variants.push(...getStringCombinations(words));
            result = (() => {
                for (const word of variants) {
                    for (const hit of response.hits) {
                        if (hit['Adjusted Title'].toLowerCase() === word) {
                            return {
                                url: `/collections/${hit.Handle}`,
                                categoryName: hit['Adjusted Title'],
                                categoryType: hit['Template Suffix'],
                                position: response.hits.indexOf(hit) + 1
                            };
                        }
                    }
                }
                return null;
            })();
        }
    }
    catch (e) {
        console.log(e);
    }
    return result;
};
class ComponentSearchForm extends HTMLElement {
    _loading = false;
    windowLoading = true;
    disabled = true;
    updateProcess = false;
    suggestionsOpened = false;
    isRecognitionActive = false;
    value = '';
    componentVNodes = [];
    inputType;
    trendingItems = [];
    recentData = JSON.parse(window.sessionStorage.getItem(SESSION_KEY) ?? '[]');
    popItems = [];
    redirectTo = null;
    overlay = document.querySelector('.main-overlay');
    constructor() {
        super();
        this.documentClickHandler = this.documentClickHandler.bind(this);
        if (recognition !== undefined) {
            if (window.navigator.permissions !== undefined) {
                void window.navigator.permissions.query({
                    name: 'microphone'
                }).then((result) => {
                    if (result.state === 'prompt') {
                        runAfterWinLoadEvent(() => {
                            this.windowLoading = false;
                            this.render();
                        });
                    }
                    else {
                        this.windowLoading = false;
                        this.render();
                    }
                });
            }
            else {
                runAfterWinLoadEvent(() => {
                    this.windowLoading = false;
                    this.render();
                });
            }
        }
        else {
            this.windowLoading = false;
        }
    }
    get loading() {
        return this._loading;
    }
    set loading(val) {
        this._loading = val;
        if (val) {
            this.hideSuggestions();
        }
        else {
            this.render();
        }
    }
    addItemToRecent(name, link) {
        this.recentData = [
            { name, link },
            ...this.recentData.filter(item => item.name !== name)
        ];
        if (this.recentData.length > 5) {
            this.recentData.length = 5;
        }
        window.sessionStorage.setItem('r_searches', JSON.stringify(this.recentData));
    }
    toggleFullscreenMode() {
        if (this.suggestionsOpened) {
            toggleBodyScroll(true);
            this.classList.add(...mobileFullscreenClasses);
            this.classList.remove('pt:12');
            this.style.height = 'var(--lock-sh, 100vh)';
            stickyWrapper?.classList.add('z:800');
        }
        else {
            toggleBodyScroll(false);
            this.classList.remove(...mobileFullscreenClasses);
            this.classList.add('pt:12');
            this.style.height = 'auto';
            stickyWrapper?.classList.remove('z:800');
        }
    }
    toggleOverlay() {
        if (this.overlay === null)
            return;
        if (this.suggestionsOpened) {
            this.overlay.setAttribute('style', '--z-index: 296; transition: opacity .2s ease; background: rgb(255 255 255 / 90%);');
            this.overlay.setAttribute('aria-hidden', 'false');
        }
        else {
            this.overlay.setAttribute('aria-hidden', 'true');
            this.overlay.removeAttribute('style');
        }
    }
    showSuggestions() {
        if (this.suggestionsOpened)
            return;
        this.suggestionsOpened = true;
        if (MEDIA_BREAKPOINTS.LG_UP.matches) {
            this.toggleOverlay();
            document.addEventListener('mousedown', this.documentClickHandler);
        }
        else {
            this.toggleFullscreenMode();
        }
        this.render();
    }
    hideSuggestions() {
        if (!this.suggestionsOpened)
            return;
        this.suggestionsOpened = false;
        if (MEDIA_BREAKPOINTS.LG_UP.matches) {
            this.toggleOverlay();
            document.removeEventListener('mousedown', this.documentClickHandler);
        }
        else {
            this.toggleFullscreenMode();
        }
        this.render();
    }
    documentClickHandler(event) {
        if (!(event.target instanceof Element) ||
            event.target === this ||
            this.contains(event.target)) {
            return;
        }
        this.hideSuggestions();
    }
    form = (() => {
        let addInfo = '';
        let inputValue = '';
        if (recognition !== undefined) {
            recognition.addEventListener('result', (event) => {
                let interimResult = '';
                const prevValue = this.value;
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    if (event.results[i].isFinal) {
                        this.value += event.results[i][0].transcript;
                        this.inputType = 'voice';
                    }
                    else {
                        interimResult += event.results[i][0].transcript;
                    }
                }
                inputValue = this.value + interimResult;
                updateForm();
                if (prevValue !== this.value && this.value.length > 2) {
                    if (!isSearchPage) {
                        !this.suggestionsOpened
                            ? this.showSuggestions()
                            : this.render();
                    }
                    submit();
                    recognition.stop();
                }
            });
            recognition.addEventListener('speechend', () => {
                recognition.stop();
            });
            recognition.addEventListener('start', () => {
                this.value = '';
                inputValue = '';
                addInfo = 'Speak now';
                this.isRecognitionActive = true;
                updateForm();
                dlDispatchAmplEvent('search_recognition_start');
            });
            recognition.addEventListener('end', () => {
                if (!this.isRecognitionActive)
                    return;
                addInfo = '';
                this.isRecognitionActive = false;
                updateForm();
                dlDispatchAmplEvent('search_recognition_end');
            });
            let resetTimeout = 0;
            recognition.addEventListener('error', () => {
                addInfo = 'Microphone access is blocked';
                updateForm();
                resetTimeout > 0 && window.clearTimeout(resetTimeout);
                resetTimeout = window.setTimeout(() => {
                    addInfo = '';
                    updateForm();
                }, 999);
            });
        }
        const submitHandler = () => {
            const target = this.redirectTo?.url ?? `/search${this.value.length > 0 ? `?q=${this.value}` : ''}`;
            this.addItemToRecent(this.value, target);
            if (this.redirectTo !== null) {
                dlDispatchAmplEvent('search_to_collection', {
                    query: this.value,
                    inputType: this.inputType,
                    target: this.redirectTo.url,
                    items: [{
                            category_name: this.redirectTo.categoryName,
                            category_type: this.redirectTo.categoryType,
                            position: this.redirectTo.position
                        }]
                });
            }
            if (target.includes('search') && isSearchPage) {
                this.dispatchEvent(new CustomEvent('newSearch', {
                    detail: this.value
                }));
                this.loading = false;
                document.activeElement?.blur();
            }
            else {
                window.location.href = target;
            }
        };
        const submit = (e) => {
            e?.preventDefault();
            this.loading = true;
            if (this.updateProcess) {
                const interval = window.setInterval(() => {
                    if (this.updateProcess)
                        return;
                    clearInterval(interval);
                    submitHandler();
                }, 200);
            }
            else {
                submitHandler();
            }
        };
        const createForm = () => {
            const isEmpty = MEDIA_BREAKPOINTS.LG_UP.matches || inputValue.length < 1;
            return create('form', {
                key: 'form',
                action: '/search',
                class: 'pos:r z:2 d:flex ai:center bg:ebedee',
                events: {
                    submit
                }
            }, [
                create('s-svg', {
                    key: 'icon',
                    'data-icon': '#icon__header_search',
                    class: 'pos:a l:10 t:50p trf:ty:-50p h:20 w:20 color:text-light pev:none',
                    hidden: !isEmpty
                }),
                create('input', {
                    key: 'input',
                    type: 'search',
                    class: `ol w:100p lts:002 fz:16 ${isEmpty ? 'pl:40' : 'pl:10'} pr:10 py:10 color:text bg:none`,
                    name: 'q',
                    autocomplete: 'off',
                    placeholder: recognition !== undefined &&
                        !MEDIA_BREAKPOINTS.LG_UP.matches && addInfo.length > 0
                        ? addInfo
                        : this.dataset.placeholder,
                    value: inputValue,
                    events: {
                        input: (e) => {
                            const prevLength = this.value.length;
                            this.value = inputValue = e.currentTarget.value;
                            this.inputType = 'text';
                            if (this.value.length < 1) {
                                this.render();
                                return;
                            }
                            if (prevLength < 1) {
                                updateForm();
                            }
                            this.debouncedRender();
                        },
                        focus: () => {
                            this.showSuggestions();
                        }
                    }
                }),
                !this.loading &&
                    this.value.length > 0 &&
                    create('button', {
                        key: 'clear',
                        type: 'button',
                        class: 'btn:cleared py:6 px:10 d:flex',
                        events: {
                            click: () => {
                                inputValue = '';
                                this.value = '';
                                this.render();
                            }
                        }
                    }, create('s-svg', {
                        'data-icon': '#icon--close-x',
                        class: 'h:10 w:10 pev:none color:text-light'
                    })),
                ...(this.loading || this.windowLoading
                    ? [
                        create('div', { key: 'loader', class: 'mx:10' }, create('div', { class: 'icon--loader fz:20' }))
                    ]
                    : recognition !== undefined
                        ? [
                            MEDIA_BREAKPOINTS.LG_UP.matches && addInfo.length > 0 &&
                                create('span', { key: 'info', class: 'fz:14 mx:6 text:nowrap' }, addInfo),
                            create('button', {
                                key: 'recognition',
                                type: 'button',
                                class: 'btn:cleared py:6 px:10 d:flex',
                                title: 'Click the microphone and start speaking',
                                events: {
                                    click: () => {
                                        if (this.isRecognitionActive) {
                                            recognition.stop();
                                        }
                                        else {
                                            recognition.start();
                                        }
                                    }
                                }
                            }, create('s-svg', {
                                'data-icon': '#icon--microphone',
                                class: `h:28 pev:none ${this.isRecognitionActive
                                    ? 'color:accent-red'
                                    : 'color:text-light'}`
                            }))
                        ]
                        : [])
            ]);
        };
        let formVNode = createForm();
        const updateForm = () => {
            const newVNode = createForm();
            if (formVNode._el !== undefined) {
                patch(formVNode, newVNode);
            }
            formVNode = newVNode;
        };
        return () => {
            formVNode = createForm();
            return formVNode;
        };
    })();
    suggestions() {
        let canceled = false;
        if (this.value.length < 3) {
            this.popItems = [];
            this.redirectTo = null;
            this.updateProcess = false;
        }
        const createSuggestions = () => {
            const trendingItems = this.trendingItems.length > 0 &&
                suggestionListItems({
                    label: 'Trending Searches',
                    children: this.trendingItems.map(({ name, link }) => (suggestionListItem({
                        href: link,
                        icon: '#icon__header_trending',
                        label: name,
                        clickHandler: () => {
                            this.addItemToRecent(name, link);
                            this.loading = true;
                            this.hideSuggestions();
                        }
                    })))
                });
            const recentItems = this.recentData.length > 0 &&
                suggestionListItems({
                    label: 'Recent Searches',
                    children: [
                        ...this.recentData.map(({ name, link }) => (suggestionListItem({
                            href: link,
                            icon: '#icon__header_search',
                            label: name,
                            clickHandler: () => {
                                this.addItemToRecent(name, link);
                                this.loading = true;
                                this.hideSuggestions();
                            }
                        }))),
                        create('button', {
                            class: 'fz:16 btn:cleared fw:400 mt:14 px:10 px:16:lg-up hover:text:underline',
                            events: {
                                click: () => {
                                    this.recentData = [];
                                    window.sessionStorage.removeItem(SESSION_KEY);
                                    updateSuggestions();
                                }
                            }
                        }, ['Clear Recent Searches'])
                    ]
                });
            const popularItems = this.popItems.length > 0 &&
                suggestionListItems({
                    label: 'Popular Searches',
                    children: this.popItems.map(({ Handle, _highlightResult, Parent, 'Adjusted Title': title, 'Template Suffix': suffix }, index) => (suggestionListItem({
                        href: `/collections/${Handle}`,
                        icon: '#icon__header_search',
                        label: _highlightResult['Adjusted Title'].value.replace(/em>/g, 'b>'),
                        parent: Parent.length > 0 ? `in ${Parent}` : suffix.replace('topic', 'subject'),
                        clickHandler: () => {
                            dlDispatchAmplEvent('click_suggestions', {
                                items: [{
                                        category_name: title,
                                        category_type: suffix,
                                        position: index + 1
                                    }]
                            });
                            this.addItemToRecent(title, `/collections/${Handle}`);
                            this.loading = true;
                            this.hideSuggestions();
                        }
                    })))
                });
            return create('div', {
                key: 'suggestions',
                class: `d:grid gap:28 ${MEDIA_BREAKPOINTS.LG_UP.matches
                    ? 'pos:a z:2 t:100p l:0 w:100p bxsh:1 bg:white px:12 py:32 ol ol:w:1 gtc:2'
                    : 'pb:28 ov:y:a mt:14'}`,
                willUpdate: () => {
                    canceled = true;
                }
            }, popularItems !== false
                ? popularItems
                : MEDIA_BREAKPOINTS.LG_UP.matches
                    ? [trendingItems, recentItems]
                    : [recentItems, trendingItems]);
        };
        let suggestionsVNode = createSuggestions();
        const updateSuggestions = () => {
            const newSuggestions = createSuggestions();
            if (suggestionsVNode._el !== undefined) {
                patch(suggestionsVNode, newSuggestions);
            }
            suggestionsVNode = newSuggestions;
        };
        if (this.value.length > 2) {
            this.updateProcess = true;
            void CLIENT.search(this.value, {
                explain: ['*'],
                ignorePlurals: true
            }).then(result => {
                if (canceled)
                    return;
                this.popItems = result?.hits?.slice(0, 5) ?? [];
                this.suggestionsOpened && updateSuggestions();
                this.redirectTo = getRedirectFromResponse(result);
                this.updateProcess = false;
            });
        }
        return suggestionsVNode;
    }
    render() {
        const newVNodes = [];
        if (!MEDIA_BREAKPOINTS.LG_UP.matches && this.suggestionsOpened) {
            newVNodes.push(backBtn({
                clickHandler: this.hideSuggestions.bind(this)
            }));
        }
        newVNodes.push(this.form());
        this.suggestionsOpened && newVNodes.push(this.suggestions());
        patch(this.componentVNodes, newVNodes, this);
        this.componentVNodes = newVNodes;
    }
    debouncedRender = debounce(this.render.bind(this), 300);
    connectedCallback() {
        const trendingItemsJson = this.querySelector('[data-component-trending-items]')?.textContent;
        if (isNotNullOrUndef(trendingItemsJson)) {
            this.trendingItems = JSON.parse(trendingItemsJson);
        }
        this.innerHTML = '';
        this.render();
    }
}
window.customElements.define('search-form-component', ComponentSearchForm);
